var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 637,
    height: 412,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#81BEDA",
    d: "M0 0h637v412H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 637,
    height: 412,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#81BEDA",
    d: "M0 0h637v412H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m422.28 214.53-239.32 21.8 15.3 167.82 239.31-21.81-15.29-167.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M243.5 295.51c-.7.21-1.4.42-1.99.73-.7-.1-1.4-.28-2.1-.27a26.5 26.5 0 0 0-4.9-.03c-3.5.35-6.69 1.3-9.26 2.73a9.89 9.89 0 0 1 8.78-8.23c2.7-.24 5.2.63 7.13 2.3a6.94 6.94 0 0 1 2.34 2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M258 295.6a24.66 24.66 0 0 0-9.6-.96c-1.7.13-3.3.45-4.8.87-.7.2-1.4.42-1.99.73-.7-.1-1.4-.28-2.1-.27.38-1.2.97-2.32 1.75-3.33a9.72 9.72 0 0 1 6.65-3.5 9.67 9.67 0 0 1 10.1 6.47ZM275.1 280.66c-.7-.09-1.4-.08-2.1-.07-.61-.39-1.21-.68-1.92-1.07a30.25 30.25 0 0 0-4.52-1.74 23.2 23.2 0 0 0-9.62-.76 9.74 9.74 0 0 1 11.14-4.56c2.61.77 4.63 2.44 5.97 4.62.51 1.1.83 2.29 1.05 3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M288.57 285.77a24.1 24.1 0 0 0-8.66-4.27 20.3 20.3 0 0 0-4.81-.84c-.7-.09-1.4-.08-2.1-.07-.61-.39-1.21-.68-1.92-1.07a9.56 9.56 0 0 1 2.87-2.44 9.71 9.71 0 0 1 7.48-.9 9.87 9.87 0 0 1 7.14 9.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4FD2D6",
    d: "m449.18 226.24-268.36 24.44 12.8 140.6 268.36-24.44-12.8-140.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#368E91",
    d: "M209.1 360.53a34.64 34.64 0 0 0-.88 11.57 34.58 34.58 0 0 0 6.48 17.26l214.16-19.5a56.68 56.68 0 0 0 12.63-30.5l-232.4 21.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44B4B8",
    d: "M441.52 328.63a56.79 56.79 0 0 0-76.87-47.91A68.92 68.92 0 0 0 307.87 259a69.1 69.1 0 0 0-62.2 59.8 13.6 13.6 0 0 0-14.6 17.45 34.73 34.73 0 0 0-21.97 24.27l232.39-21.16c.34-3.51.37-7.1.03-10.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9F9C",
    d: "M343.95 265.85a17.01 17.01 0 0 1-20.39 18.21 17.02 17.02 0 0 1 1.92-33.62 17.01 17.01 0 0 1 18.47 15.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBCBA",
    d: "M334.07 266.75a17.02 17.02 0 0 1-10.51 17.31 17.01 17.01 0 0 1-2.96-32.43 17.03 17.03 0 0 1 13.47 15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M235.59 274.16A16.35 16.35 0 0 0 221 287.4l31.31-2.85a16.38 16.38 0 0 0-16.73-10.39ZM278.3 270.27a16.35 16.35 0 0 0-14.58 13.24l31.32-2.85a16.38 16.38 0 0 0-16.74-10.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M257.49 267.07a23.37 23.37 0 0 0-20.83 18.92l44.73-4.08a23.37 23.37 0 0 0-23.9-14.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B7375",
    d: "m389.07 360.06-124.95 11.38a4.2 4.2 0 0 1-.76-8.37L388.3 351.7a4.2 4.2 0 1 1 .77 8.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3C3E54",
    strokeMiterlimit: 10,
    strokeWidth: 2.15,
    d: "m309.47 296.97-1.93-21.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E728F",
    d: "M307.3 279.84c1.48-.14 2.26-.52 2.9-.82.53-.25.9-.43 1.82-.51.92-.09 1.33.02 1.9.18.67.18 1.51.4 3 .27 1.48-.13 2.26-.51 2.9-.81.52-.25.9-.44 1.82-.52.92-.08 1.32.03 1.89.18.68.19 1.52.41 3 .28 1.48-.14 2.27-.52 2.9-.82.53-.25.9-.43 1.83-.52l-.93-1.45.64-1.68c-1.48.13-2.27.51-2.9.81-.53.25-.9.44-1.83.52-.91.09-1.32-.03-1.88-.18a7.5 7.5 0 0 0-3-.28c-1.49.14-2.27.52-2.9.82-.53.25-.91.43-1.83.52-.92.08-1.33-.03-1.89-.18a7.5 7.5 0 0 0-3-.28c-1.49.13-2.27.51-2.9.81-.53.25-.91.44-1.83.52l.29 3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3E54",
    d: "M309.52 297.53a.56.56 0 1 0-.1-1.12.56.56 0 0 0 .1 1.12ZM307.58 276.13a.4.4 0 1 0-.08-.8.4.4 0 0 0 .08.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7975",
    d: "M210.72 265.11c-3.7.34-6.6 3.1-7.26 6.6l15.6-1.43a8.16 8.16 0 0 0-8.34-5.17ZM231.99 263.18c-3.7.33-6.6 3.1-7.27 6.59l15.6-1.42a8.16 8.16 0 0 0-8.33-5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7975",
    d: "M221.62 261.58c-5.3.48-9.43 4.44-10.37 9.41l22.27-2.03a11.63 11.63 0 0 0-11.9-7.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B3E54",
    d: "m279.46 286.66-2.88 4.16-3.59-3.57-2.88 4.15-.85-.83-37.8 69.48 54.24-4.94-6.23-68.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8FEFF",
    d: "m273 287.25 3.58 3.57 2.88-4.16.01.01-1.16-12.75-9.05 16.64.85.84 2.88-4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCF0F2",
    d: "m283.06 290.23 2.88-4.16 3.59 3.57.68-1-11.9-14.72 1.16 12.75 3.59 3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292B3B",
    d: "m290.21 288.65-.68.99-3.59-3.57-2.88 4.16-3.59-3.56 6.23 68.44 54.25-4.94-49.74-61.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B3E54",
    d: "m350.5 267.42-3.3 4.9-4.14-4.22-3.3 4.9-.98-1-43.27 82.21 62.39-5.68-7.39-81.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8FEFF",
    d: "m343.06 268.1 4.13 4.23 3.31-4.9h.01l-1.37-15.11L338.78 272l.97 1 3.3-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCF0F2",
    d: "m354.64 271.65 3.31-4.9 4.14 4.22.79-1.17-13.74-17.48 1.37 15.1 4.13 4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292B3B",
    d: "m362.88 269.8-.8 1.17-4.13-4.23-3.31 4.91-4.13-4.23 7.39 81.1 62.39-5.67-57.42-73.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B3E54",
    d: "m309.88 299.67-2.3 3.21-2.85-2.74-2.3 3.21-.68-.64-30.25 53.69 43.2-3.94-4.81-52.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8FEFF",
    d: "m304.73 300.14 2.85 2.75 2.3-3.22-.89-9.82-7.24 12.86.68.64 2.3-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCF0F2",
    d: "m312.74 302.42 2.3-3.22 2.85 2.75.55-.77-9.45-11.33.9 9.83 2.85 2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292B3B",
    d: "m318.44 301.18-.55.77-2.85-2.75-2.3 3.22-2.85-2.74 4.8 52.79 43.21-3.94-39.46-47.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D7085",
    d: "m413.22 321.39-2.48 7.1 1.18-.11-1.67 4.76 1.36-.13-2.17 6.19 1.82-.16-2.7 7.73 6.92-.63-2.26-24.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585C7A",
    d: "m418.34 338.39 1.81-.17-3.25-5.69 1.37-.12-2.5-4.38 1.17-.1-3.72-6.54 2.25 24.75 6.93-.63-4.06-7.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D7085",
    d: "m428.62 306.13-3.86 11.04 1.83-.17-2.59 7.4 2.12-.2-3.37 9.63 2.82-.25-4.2 12.03 10.76-.98-3.5-38.5ZM230.56 320.55l-3.86 11.03 1.83-.16-2.59 7.39 2.12-.2-3.37 9.64 2.82-.26-4.2 12.03 10.76-.98-3.51-38.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585C7A",
    d: "m238.52 346.99 2.82-.26-5.05-8.86 2.11-.2-3.87-6.8 1.82-.16-5.79-10.16 3.5 38.5 10.77-.99-6.3-11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7975",
    d: "M338.4 293.72a5.7 5.7 0 0 0-5.09 4.61l10.92-.99a5.7 5.7 0 0 0-5.84-3.62ZM353.28 292.36a5.7 5.7 0 0 0-5.08 4.62l10.91-1a5.7 5.7 0 0 0-5.83-3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7975",
    d: "M346.03 291.24c-3.7.34-6.6 3.1-7.26 6.6l15.6-1.43a8.15 8.15 0 0 0-8.34-5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M350.48 296.01a3.65 3.65 0 0 0-3.25 2.95l6.97-.63a3.63 3.63 0 0 0-3.72-2.32ZM359.98 295.15a3.65 3.65 0 0 0-3.25 2.95l6.97-.64a3.62 3.62 0 0 0-3.72-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M355.36 294.43a5.2 5.2 0 0 0-4.64 4.22l9.96-.91a5.2 5.2 0 0 0-5.32-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9F9C",
    d: "M230.63 352.69A14.17 14.17 0 0 0 218 364.15l27.12-2.46a14.17 14.17 0 0 0-14.49-9ZM267.63 349.32A14.17 14.17 0 0 0 255 360.79l27.12-2.48a14.17 14.17 0 0 0-14.5-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9F9C",
    d: "M249.6 346.54c-9.2.84-16.4 7.73-18.04 16.39l38.74-3.53a20.22 20.22 0 0 0-20.7-12.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M367.22 288.93c.62-.15 1.08-.7 1.1-1.34 0-.01.03-.02.04 0 .14.62.7 1.09 1.33 1.11.02 0 .02.02 0 .03-.62.15-1.08.7-1.1 1.34h-.04a1.44 1.44 0 0 0-1.33-1.11c-.02-.01-.02-.03 0-.03ZM256.62 339.58c.62-.14 1.08-.7 1.1-1.33 0-.02.03-.02.04 0 .14.62.69 1.08 1.33 1.1.02 0 .02.03 0 .04-.62.14-1.08.7-1.1 1.33 0 .02-.03.02-.04 0a1.44 1.44 0 0 0-1.33-1.1c-.02-.01-.02-.04 0-.04ZM286.5 307.5a2.62 2.62 0 0 0 2.03-2.42c0-.03.04-.03.06 0a2.62 2.62 0 0 0 2.42 2.02c.03 0 .04.03 0 .05a2.62 2.62 0 0 0-2.01 2.43c0 .03-.04.03-.06 0a2.62 2.62 0 0 0-2.43-2.02c-.03 0-.03-.05 0-.05ZM300.25 268.56a2.62 2.62 0 0 0 2.02-2.44c0-.02.04-.03.05 0a2.62 2.62 0 0 0 2.43 2.02c.03 0 .03.04 0 .06a2.62 2.62 0 0 0-2.01 2.43c0 .03-.04.03-.06 0a2.62 2.62 0 0 0-2.43-2.02c-.03-.01-.03-.05 0-.05ZM360.14 283.34a2.62 2.62 0 0 0 2.03-2.43c0-.03.04-.03.05 0a2.62 2.62 0 0 0 2.43 2.02c.03 0 .03.04 0 .06a2.62 2.62 0 0 0-2.02 2.43c0 .02-.03.03-.05 0a2.62 2.62 0 0 0-2.43-2.02c-.03-.01-.03-.05 0-.06ZM273.33 298.92c.63-.15 1.09-.7 1.12-1.33 0-.02.02-.02.02 0 .15.62.7 1.08 1.34 1.1v.04c-.62.14-1.09.69-1.11 1.33 0 .02-.02.02-.03 0a1.44 1.44 0 0 0-1.33-1.1c-.03 0-.03-.03 0-.04ZM386.28 318.53c.63-.15 1.1-.7 1.12-1.33 0-.02.02-.02.03 0 .14.62.69 1.08 1.33 1.1.01 0 .02.03 0 .03-.62.15-1.08.7-1.1 1.34 0 .02-.03.02-.04 0a1.44 1.44 0 0 0-1.33-1.1c-.02-.01-.02-.04 0-.04ZM297.88 288.18c.63-.14 1.09-.69 1.11-1.33 0-.02.02-.02.03 0 .15.62.7 1.08 1.34 1.1v.04c-.63.14-1.09.7-1.11 1.33 0 .02-.02.02-.03 0a1.44 1.44 0 0 0-1.34-1.1v-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCF0F2",
    d: "M383.9 277.85c-5.84.53-10.41 4.9-11.45 10.4l24.58-2.24a12.85 12.85 0 0 0-13.14-8.16ZM417.43 274.8c-5.84.53-10.4 4.9-11.45 10.4l24.59-2.25a12.85 12.85 0 0 0-13.14-8.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCF0F2",
    d: "M401.09 272.28c-8.34.76-14.87 7-16.35 14.85l35.12-3.2a18.35 18.35 0 0 0-18.77-11.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7975",
    d: "M385.98 285.61a6.74 6.74 0 0 0-6 5.47l12.91-1.18a6.75 6.75 0 0 0-6.9-4.29ZM403.6 284.01a6.74 6.74 0 0 0-6.01 5.46l12.9-1.18a6.74 6.74 0 0 0-6.9-4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7975",
    d: "M395.02 282.68a9.63 9.63 0 0 0-8.58 7.8l18.44-1.67a9.64 9.64 0 0 0-9.86-6.13Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M156.52 166.15s9.1-7.1 9.2-10c0-2.9-9.4 2.9-11.9 9.4l2.7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292B3B",
    d: "M157.02 168.25c-.9-1.7-1.7-3.4-2.6-5.2-29.8 14.6-27.9 15.2-62.1 8.8-5.2-1-4.6 1.9-4.9 5.3-.7.2-.7.1 0 0-.3 3.4 1.4 3.9 5.6 4.6 27.6 4.6 41.4 3.5 64-13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.92 238.35s-3.4 11-1.8 13.4c1.6 2.4 6.1-7.7 4.4-14.5l-2.6 1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292B3B",
    d: "M61.22 239.35c1.9-.2 3.8-.2 5.8-.4-1.7-33.1-3-31.6 16.3-60.5 3-4.4.1-5-2.9-6.6.1-.7.2-.7 0 0-2.9-1.6-4.1-.2-6.4 3.4-15.1 23.4-19.5 36.6-12.8 64.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M92.12 366.05h-.4c-1.2-.2-2-1.4-1.7-2.6l3.2-15.8c.2-1.2 1.4-2 2.6-1.7 1.2.2 2 1.4 1.7 2.6l-3.2 15.8c-.2.9-1.1 1.7-2.2 1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292B3B",
    d: "M97.02 356.85c-2.4-.1-4.8-.3-7.1-.7 7.1-37.9 12.5-88.9-6.5-124.4 5.8-2.8 11.6-5.6 17.4-8.3 13.8 30.9 2 100.7-3.8 133.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M89.32 363.05s-1.4 5.8 0 5.9c1.4.2 21.4.8 21.5-.2.4-3.2-15.9-6.1-17.5-5.8-1.6.4-3.8-.8-4 .1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.42 365.45c-.1 0-.3-.1-.4-.1-1.1-.5-1.7-1.8-1.2-2.9l6.2-14.9c.5-1.1 1.8-1.7 2.9-1.2 1.1.5 1.7 1.8 1.2 2.9l-6.2 14.9c-.4 1-1.4 1.6-2.5 1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B3E54",
    d: "M58.92 355.95a54 54 0 0 1-6.7-2.5c16.7-34.8 35.2-82.6 26.1-121.8 6.3-1.2 12.6-2.4 18.9-3.5 5.3 33.5-24.2 97.8-38.3 127.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M49.62 363.05s-1.4 5.8 0 5.9c1.4.2 21.4.8 21.5-.2.4-3.2-15.9-6.1-17.5-5.8-1.7.4-3.8-.8-4 .1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#292B3B",
    d: "M106.02 236.35c-3.8-1.3-11.6.8-15.3 0-5.5-1.1-8.3-.7-13.7-.4-.7-17.2-.1-35.2-1.4-52-.3-3.5-.4-5.7.2-8.3.9-3.6 2.7-6 5.2-7.3 3-1.6 6.7-1.5 10.6.5.5.3 1.1.6 1.7 1 2.3 1.7 4.4 5.1 4.7 11.5.7 15.9 4.9 38.5 8 55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCF0F2",
    d: "m93.12 169.85-.3 10.8-.4 13.5-5.6-12.6-5.9-13.2c3-1.6 6.7-1.5 10.6.5.5.2 1.1.5 1.6 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M81.72 157.95c3.7 5.7 10.6 7.7 14.1 5.5 3.5-2.3 2.1-8-1.5-13.6s-8.4-6.7-11.9-4.5-4.4 6.9-.7 12.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80.42 161.55c.9 1.3 3.3 2.2 4.2 1.5 1-.6.5-1.9-.4-3.2-.9-1.3-2.4-2.1-3.4-1.4-.9.7-1.2 1.8-.4 3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m82.52 156.95 7.1-.7c.1 1 .8 10.2.5 13.7-.3 1.1-2 1.6-3.9 1.1-1.7-.4-3-1.5-3-2.5.1-2-.3-8.2-.7-11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M85.22 159.85c1-1.1 2-.1 4.5 1.3 2.5 1.4 7 1 7.3-4.8.2-3.7 2.3 2.4 2.3 2.4.4 3.1-.4 4.9-2.5 6.3-2.8 1.8-7.4 1.6-11.4-.8-.6-1.6-.9-3.6-.2-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M97.22 156.15s-.1 0-.2.1c-1.2.7-6.9 3.8-7.4 6.1-.6 2.6 3-1 4.1-2.7 1.1-1.7 2.4-1.4 3.6-1.8 1.2-.3 1.8-1.8-.1-1.7ZM78.52 154.85s-1.2-4.4.8-7.6c2-3.2 7.6-6.5 12.1-2.2 0 0 2.9 3.3-1.4 6.5-4.3 3.1-4.8.3-5.8 3.8s-4 3-4.1 3.7l-1.6-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE5E5A",
    d: "m92.82 180.55-.4 13.5-5.6-12.5.2-8.2h2.5l3.3 7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M494.6 0 255 18.44l12.93 168 239.6-18.43L494.6 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9F9C",
    d: "m491.89 154.72-10.71-139.2-210.69 16.22 10.71 139.2 210.69-16.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7975",
    d: "M380.9 128.56a39.2 39.2 0 1 0 0-78.4 39.2 39.2 0 0 0 0 78.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F728A",
    d: "m491.95 154.7-4.53-58.83-210.69 16.22 4.53 58.82 210.69-16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M314.7 78.46c-.7.2-1.4.4-2 .7-.7-.1-1.4-.3-2.1-.3-1.6-.2-3.2-.2-4.9-.1-3.5.3-6.7 1.2-9.3 2.6.8-4.3 4.3-7.7 8.9-8.1 2.7-.2 5.2.7 7.1 2.4 1 .7 1.8 1.7 2.3 2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M329.2 78.76c-2.8-.9-6.1-1.4-9.6-1.1-1.7.1-3.3.4-4.8.8-.7.2-1.4.4-2 .7-.7-.1-1.4-.3-2.1-.3.4-1.2 1-2.3 1.8-3.3 1.6-1.9 4-3.2 6.7-3.4 4.5-.4 8.6 2.4 10 6.6ZM346.5 64.06c-.7-.1-1.4-.1-2.1-.1-.6-.4-1.2-.7-1.9-1.1-1.4-.7-2.9-1.3-4.5-1.8-3.4-1-6.7-1.3-9.6-.9 2.2-3.8 6.8-5.7 11.2-4.4 2.6.8 4.6 2.5 5.9 4.7.5 1.1.8 2.3 1 3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M359.9 69.36c-2.3-1.9-5.2-3.4-8.6-4.4-1.6-.5-3.2-.8-4.8-.9-.7-.1-1.4-.1-2.1-.1-.6-.4-1.2-.7-1.9-1.1.8-1 1.8-1.8 2.9-2.4 2.2-1.2 4.9-1.6 7.5-.8 4.3 1.3 7.1 5.3 7 9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8E91B0",
    d: "M442.7 116.66c-.2-2.2-2.1-3.9-4.3-3.7l-11.6.9c-1.4.1-2.7-1-2.8-2.4-.1-1.4 1-2.7 2.4-2.8l3.3-.3a4.02 4.02 0 0 0-.6-8l-94.1 7.2a4.02 4.02 0 0 0 .6 8l3.3-.3c1.4-.1 2.7 1 2.8 2.4.1 1.4-1 2.7-2.4 2.8l-24 1.8a4.02 4.02 0 0 0 .6 8l36.9-2.8a3.1 3.1 0 0 1 3.3 2.8 3.1 3.1 0 0 1-2.8 3.3l-16.2 1.2a4.02 4.02 0 0 0 .6 8l94.1-7.2a4.02 4.02 0 0 0-.6-8l-16.2 1.2a3.1 3.1 0 0 1-3.3-2.8 3.1 3.1 0 0 1 2.8-3.3l24.5-1.9c2.2.1 3.9-1.9 3.7-4.1ZM393.7 151.06l-43 3.3c-2.2.2-4.2-1.5-4.3-3.7-.2-2.2 1.5-4.2 3.7-4.3l43-3.3c2.2-.2 4.2 1.5 4.3 3.7.2 2.2-1.5 4.2-3.7 4.3ZM429 148.36l-18.8 1.4c-2.2.2-4.2-1.5-4.3-3.7-.2-2.2 1.5-4.2 3.7-4.3l18.8-1.4c2.2-.2 4.2 1.5 4.3 3.7.2 2.2-1.5 4.1-3.7 4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F728A",
    d: "m382.6 125.16-15.1 1.2a3.26 3.26 0 1 1-.5-6.5l15.1-1.2c1.8-.1 3.4 1.2 3.5 3a3.2 3.2 0 0 1-3 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M409.8 97.14 169.93 83 160 251.21l239.9 14.15 9.9-168.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCF0F2",
    d: "m183.52 98.3-8.22 139.37 210.94 12.43 8.22-139.36-210.94-12.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7975",
    d: "m386.29 250.06 2.25-38.23-210.94-12.44-2.25 38.24 210.94 12.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9F9C",
    d: "m387.67 226.26.85-14.48-210.94-12.43-.85 14.47 210.94 12.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9F9C",
    d: "m297.54 209.62-49.8-2.9 21.1-37.5 6.8-12.1 4.5 10.8 17.4 41.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9F9C",
    d: "m355.24 213.02-90.4-5.3 40-70.9 10.7-19 9.8 23.5 29.9 71.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8D8A",
    d: "m303.54 153.22-30.9 55 55.2 3.2-24.3-58.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9F9C",
    d: "m389.24 199.22-.9 15.8-74-4.4 45.8-81.3 29.1 69.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m325.34 141.32-2.5 6.4-4.4-7-3.2 4.8-4.8-11.6-4.2 7.2-1.4-4.3 10.7-19 9.8 23.5ZM280.14 167.92l-2.2-1.4-3.7 7-1-7.3-4.4 3 6.8-12.1 4.5 10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF7975",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.71,
    d: "m233.34 205.92 1.6-28.4M199.14 203.82l3.1-53.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44B4B8",
    d: "M237.82 196.86a14.5 14.5 0 1 0-6.34-28.3 14.5 14.5 0 0 0 6.34 28.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44B4B8",
    d: "M244.3 171.93a9.6 9.6 0 1 0-17.43-8.07 9.6 9.6 0 0 0 17.42 8.07ZM210.99 176.84a14.5 14.5 0 1 0-19.27-21.67 14.5 14.5 0 0 0 19.27 21.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44B4B8",
    d: "M186.04 179.62c.5-8 7.3-14 15.3-13.6 8 .5 14 7.3 13.6 15.3-.5 8-7.3 14-15.3 13.6-8-.5-14-7.4-13.6-15.3ZM192.64 150.62a9.62 9.62 0 1 1 19.21 1.2 9.62 9.62 0 0 1-19.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7975",
    d: "M244.14 124.12c-5.6-.3-10.6 3.2-12.4 8.2l23.7 1.4c-1.2-5.3-5.7-9.3-11.3-9.6ZM276.44 126.02c-5.6-.3-10.6 3.2-12.4 8.2l23.7 1.4c-1.2-5.3-5.7-9.3-11.3-9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7975",
    d: "M261.24 121.22c-8-.5-15.1 4.5-17.7 11.8l33.8 2c-1.6-7.5-8.1-13.3-16.1-13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D69",
    d: "m581.8 358.64 3.2-2.3c-.4-.5-36.7-55-39.4-93l-6.7.3c2.8 39 41.2 92.7 42.9 95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D69",
    d: "M516 365.84c.2-.7 22.7-65.8 24.3-102.3l-6.7-.2c-1.5 36-21.2 100.7-21.4 101.3l3.8 1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M583.6 353.24s4.1 2.7 3.4 3.6c-.7.9-12.5 12.7-13.1 12.2-2.1-1.7 6.1-12.8 7.3-13.5 1.2-.7 1.8-2.7 2.4-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M498.7 177.74s-3.4-9-5.8-9.7c-2.3-.7 0 8.2 4.6 11.8l1.2-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8B87",
    d: "M499.5 176.94c-1.5.5-2.9 1-4.3 1.7 9.7 22.8 16.1 31.7 41.5 33.1 3.9.2 4.2-1.3 3.7-4.3.6-.2.7-.2 0 0-.5-3-1.7-3.2-5.1-3.4-22.2-.9-25.5-8.5-35.8-27.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3F57",
    d: "M548.3 311.44c-1.2.8-2.3 1.7-3.4 2.5-2.6 1.9-5.5 3.4-8.4 4.8-1.7.8-3.5 1.6-5.3 2.1-2.8.7-5.7.7-8.6.3 3.8-25.8 1.9-49.4 10.2-73.9.8.3 1.6.6 2.5.9 0-.9-.1-1.9-.1-2.8 5.3.6 10.7 1.2 16 1.9-1.4 24.4 2.4 42.8 9.7 60.7-4.4-.2-8.9 1-12.6 3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M530.7 174.74c1.8-.2 4.1 1.1 4.7 2.9.7 1.8-.7 3.7-2.4 4.3-1.7.6-5.2-1.2-5.9-3-.7-1.7 1.3-4 3.6-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M536.7 172.24c3.3-2.7 9.1-3.2 12.7-.6 3.6 2.6 3.4 8 .9 11.4-2.5 3.4-10 5.5-15.7 2-3.6-2.3-2.1-9.4 2.1-12.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M534.7 184.04c2.4-2 6.7-2.5 9.2-.7 2.6 1.9 2.4 5.8.5 8.4-1.9 2.6-8.4 3.6-11 1.7-2.6-1.8-1.8-6.8 1.3-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M538.6 187.44c-2.4 5.1-7.9 7.6-11 6.1-3.1-1.5-2.7-6.3-.3-11.4 2.4-5.1 6.1-6.5 9.3-5.1 3.1 1.5 4.4 5.3 2 10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M540.1 190.24c-.6 1.2-2.5 2.2-3.3 1.8-.9-.4-.6-1.5-.1-2.7.6-1.2 1.8-2 2.6-1.6.9.4 1.3 1.3.8 2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M540.8 184.54s.5-3.8-1.6-6.2c-2-2.4-7-4.5-10.2-.5 0 0-2 3.1 1.9 5.2s4-.3 5.2 2.5c1.2 2.8 3.6 2 3.8 2.6l.9-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA9A6",
    d: "M530 258.04c4.5.1 7.9-1.4 11.7-3.7 2.9-1.8 6.7-2.5 9.7-3.8 2.2-13.9-.9-36.4-6.3-45.2-4.8-7.8-4.8-6.5-6.5-7.2-2.4-1-5.2-.7-7.1 1.1l-.1.1c-2.2 2.1-2.3 6.7-2.6 11.5-.3 4.8-2.2 3.9 2.1 12.2 1.9 3.5-1 27.8-.9 35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m536.8 188.14-5.9.5c.1.8.9 8.5 1.7 11.3.4.8 1.9 1 3.4.3 1.3-.6 2.2-1.7 2.1-2.5-.5-1.6-1.1-6.7-1.3-9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1C2E",
    d: "M517.1 362.94s1.2 4.8 0 4.9c-1.2.1-17.8.6-17.9-.1-.3-2.6 13.3-5.1 14.6-4.8 1.4.3 3.2-.7 3.3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M550 255.74s-6.9 7.4-6.5 9.9c.4 2.5 7.7-3.8 9-9.8l-2.5-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8B87",
    d: "M548.1 257.34c1.3 1 2.4 1.8 3.9 2.9 16.2-27.4 12.2-36-8.9-57.8-3.2-3.3-9.1 2.1-3.2 7.1 20.9 17.7 19.4 22.3 8.2 47.8Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m198.56 249.06 210.47-19.17 12.81 140.6-210.48 19.18z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.ff377e12736397e6ccd74170788f5429.svg";
export { ForwardRef as ReactComponent };